import type { Components } from '@mui/material/styles';

export default function MUIStepper(): Components['MuiStepper'] {
  return {};
}
